import RouteView from '@/router/RouteView.vue';
import CampusManagement from './list/index.vue';
import CampusAuthorize from './list/authorize/index.vue';
import Auth from './list/authorization/index';
import Factor from './factor/index.vue';
import RelevanceCampus from './factor/relevanceCampus.vue';
import CampusYun from './campusYun/index';
import CampusYunPt from './campusYunPt/index';

export default [
  {
    path: '/campus',
    component: RouteView,
    redirect: '/campus',
    meta: {
      title: '校区管理',
    },
    children: [
      {
        path: '/campus',
        name: 'Campus',
        component: CampusManagement,
        meta: {
          title: '校区列表',
        },
      },
      {
        path: '/school/authorize',
        name: 'CampusAuthorize',
        component: CampusAuthorize,
        meta: {
          title: '授权统计',
        },
      },
      {
        path: '/campus/yun',
        name: 'campusYun',
        component: CampusYun,
        meta: {
          title: '擎想系统课件',
        },
      },
      {
        path: '/campus/yunPt',
        name: 'campusYunPt',
        component: CampusYunPt,
        meta: {
          title: '授权擎想系统',
        },
      },
    ],
  },
  {
    path: '/factor',
    name: 'Factor',
    component: RouteView,
    redirect: '/factor/list',
    meta: {
      title: '代理商管理',
    },
    children: [
      {
        path: '/factor/list',
        name: 'FactorList',
        component: Factor,
        meta: {
          title: '代理商列表',
        },
      },
      {
        path: '/factor/relevance-campus/:id/:name',
        name: 'relevanceCampus',
        component: RelevanceCampus,
        meta: {
          title: '关联校区',
        },
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/CampusManagement/index.js